import Config from '../Config';
import Pattern from './Pattern';

export default class Helper {
	static dev() {
		const dev = ['localhost'];
		return dev.includes(window.location.hostname);
	}

	static environment() {
		return Helper.dev() ? 'dev' : 'production';
	}

	static endpoint(uri) {
		const environment = Helper.environment();
		const base = Config.api[environment];
		const url = `${base}/${uri}`;
		return url;
	}

	static type(content, type) {
		return typeof content === type;
	}

	static undefined(content) {
		return Helper.type(content, 'undefined');
	}

	static equals(content, check) {
		const equals = false;
		if (Array.isArray(content)) {
			const lower = content.map(item => item.toLowerCase());
			equals = lower.includes(check.toLowerCase());
		}
		else equals = content.toLowerCase() === check.toLowerCase();
		return equals;
	}

	static className(object) {
		const content = object.toString();
		return Pattern.get(content, /class\s+([^\s]+)/, '');
	}

	static is() {
		const empty = content => {
			let empty = true;
			for (const key in content) {
				empty = false;
				break;
			}

			return empty;
		};

		let is = false;
		for (const content of arguments) {
			switch (typeof content) {
				case 'boolean': is = content; break;
				case 'object': is = !empty(content); break;
				default: is = !!content; break;
			}

			if (!is) break;
		}

		return is;
	}
}
